import React from 'react';
import { Flex, Loading } from '@lucidhq/lucidium';
export var LoadingPage = function () { return (React.createElement(Flex, { lss: { m: 'auto', width: '100%', height: 'calc(100vh - 80px)' } },
    React.createElement(Loading, { message: "Please wait..." }))); };
//# sourceMappingURL=LoadingPage.js.map